<template>
  <div id="login-container" style="text-align: left; width: 100%; height: 100%;">
    <div style="height: 36px; line-height: 36px; padding-top: 20px; margin-left: 200px;">
      <!-- <img src="../assets/logo.png" style="vertical-align: middle;">
      <img src="../assets/pic.png" style="vertical-align: middle;">-->
    </div>
    <el-row
      style="text-align: center; width: 1000px; height: calc(100% - 356px); margin: 150px auto;"
    >
      <el-col :span="24" style="width: 550px; height: 100%; display: flex; align-items: center;">
        <!-- <img src="../assets/login.png"> -->
        <!-- <p style="margin-top: 50px;">中等职业教育内容与技术服务专家</p> -->
      </el-col>
      <el-col :span="5" style="width: 400px; height: 100%; display: flex; align-items: center;">
        <div style="width: 400px; background: #fff; border-radius:4px; padding: 30px 50px;">
          <span class="login-type" style="font-size: 18px; color: #42464F;">注册</span>

          <el-form
            ref="registerForm"
            :model="registerForm"
            :rules="rules"
            class="login-form"
            label-position="left"
            label-width="0px"
            v-loading="loading"
          >
            <el-form-item prop="name">
              <el-input
                type="text"
                v-model="registerForm.name"
                auto-complete="off"
                placeholder="姓名"
              ></el-input>
            </el-form-item>
            <el-form-item prop="phone" :error="errorMsg">
              <el-input
                type="text"
                id="phone"
                v-model="registerForm.phone"
                auto-complete="off"
                placeholder="手机号"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <el-input
                class="captcha"
                id="captcha"
                type="text"
                style="width: 58%;"
                v-model="registerForm.captcha"
                auto-complete="off"
                placeholder="请输入验证码"
              ></el-input>
              <el-button
                class="captcha"
                :type="show ? 'primary' : 'info'"
                style="width: 40%;"
                @click.prevent="receiveCaptcha"
                :disabled="disabled = !show"
              >
                <span v-show="show">获取验证码</span>
                <span v-show="!show" class="count">{{count}}s后重新获取</span>
              </el-button>
            </el-form-item>
            <el-form-item prop="aliAccount">
              <el-input
                type="text"
                v-model="registerForm.aliAccount"
                auto-complete="off"
                placeholder="支付宝账号"
              ></el-input>
            </el-form-item>
            <el-form-item prop="school">
              <el-input
                type="text"
                v-model="registerForm.school"
                auto-complete="off"
                placeholder="学校"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="registerForm.password"
                auto-complete="off"
                placeholder="密码(6-16位字符组成)"
              ></el-input>
            </el-form-item>
            <!-- <el-checkbox class="login-remember" v-model="checked" label-position="left">记住密码</el-checkbox> -->
            <el-form-item style="width: 100%; margin-bottom: 5px;">
              <el-button
                type="primary"
                style="width: 100%;"
                @click="register"
                :disabled="!(clicked && registerForm.agreement)"
              >注册</el-button>
            </el-form-item>
            <el-row class="lx-aggrement" style="text-align: left; margin-bottom: 20px;">
              <el-col>
                <el-checkbox v-model="registerForm.agreement">阅读并接受</el-checkbox>
                <a target="_blank" href="/agreement/1.html">《天天乐学网用户协议》</a>
              </el-col>
            </el-row>
            <p class="forget-pwd" @click="directLogin">已有帐号，直接登录></p>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
const TIME_COUNT = 60 // 更改倒计时时间
export default {
  data () {
    var validatePhone = (rule, value, callback) => {
      if (/^(?:\+?86)?1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[235-8]\d{2}|4(?:0\d|1[0-2]|9\d))|9[0-35-9]\d{2}|66\d{2})\d{6}$/.test(value) === false) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 10, message: '长度最多 10 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        aliAccount: [
          { required: true, message: '请输入支付宝账号', trigger: 'blur' },
          { max: 32, message: '长度最多 32 个字符', trigger: 'blur' }
        ],
        school: [
          { required: true, message: '请输入学校', trigger: 'blur' },
          { max: 20, message: '长度最多 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '长度至少 6 个字符', trigger: 'blur' },
          { max: 16, message: '长度最多 16 个字符', trigger: 'blur' }
        ]
      },
      checked: true,
      registerForm: { name: '', phone: '', captcha: '', aliAccount: '', school: '', password: '', agreement: false },
      loading: false,
      isAdmin: false,
      error: [],
      show: true, // 初始启用按钮
      count: '', // 初始化次数
      timer: null,
      clicked: false,
      errorMsg: ''
    }
  },

  mounted () {
  },

  methods: {
    register: function () {
      this.$refs['registerForm'].validate(valid => {
        if (valid) {
          this.loading = true
          this.$xhrPost('/register', {
            name: this.registerForm.name,
            phone: this.registerForm.phone,
            verifyCode: this.registerForm.captcha,
            password: this.registerForm.password,
            alipayAccount: this.registerForm.aliAccount,
            schoolName: this.registerForm.school,
            agreement: this.registerForm.agreement
          }).then(rs => {
            this.loading = false
            if (rs.code === 200) {
              this.$message.success('注册成功，正在跳转到登录')
              setTimeout(() => {
                this.$router.replace({ name: 'Login' })
              }, 500)
            } else if (rs.code === 409 && rs.data === 1) {
              this.$message.error('账号已存在请直接登录')
            } else if (rs.code === 409 && rs.data === 2) {
              this.$message.error('账号已存在，但是该账号无登录权限')
            } else if (rs.code === 409 && rs.data === 3) {
              this.$message.error('验证码已过期')
            } else if (rs.code === 409 && rs.data === 4) {
              this.$message.error('验证码错误')
            } else if (rs.code === 409 && rs.data === 5) {
              this.$message.error('手机号与验证码接收手机号不一致')
            }
          })
        } else {
          this.$message.error('请检查输入')
          return false
        }
      })
    },
    receiveCaptcha () {
      let phone = this.registerForm.phone
      let reg = /^1[34578]\d{9}$/
      if (reg.test(phone) === false) {
        let phone = document.getElementById('phone')
        phone.focus()
        this.errorMsg = '请输入正确的手机号'
        return false
      }
      let captcha = document.getElementById('captcha')
      captcha.focus()
      // 发送验证码请求
      this.$xhrGet(`/send-msg`, { number: this.registerForm.phone, isRegister: true }).then(rs => {
        if (rs.code === 200) {
          if (!this.timer) {
            this.count = TIME_COUNT
            this.show = false
            this.clicked = true
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.show = true
                clearInterval(this.timer) // 清除定时器
                this.timer = null
              }
            }, 1000)
          }
        } else if (rs.code === 409 && rs.data === 1) {
          this.$message.error('手机号码不存在')
        } else if (rs.code === 409 && rs.data === 2) {
          this.$message.error('验证码请求过于频繁请稍后重试')
        } else if (rs.code === 409 && rs.data === 3) {
          this.$message.error('验证码发送失败，请联系管理员')
        } else if (rs.code === 409 && rs.data === 4) {
          this.$message.error('验证码发送间隔时间需大于1分钟')
        } else if (rs.code === 409 && rs.data === 5) {
          this.$message.error('手机号不能为空')
        } else if (rs.code === 409 && !rs.data) {
          this.$message.error('该用户已在系统中存在，请直接登录')
        }
      })
    },
    directLogin () {
      this.$router.replace({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
/* #login-container { background-image: url(../assets/login-bg.png); background-position: center; background-size: 100%; } */
.login-form {
  text-align: center;
  background-clip: padding-box;
  background: #fff;
  margin-top: 40px;
}
.login-remember {
  margin-bottom: 22px;
}
.login-tips p {
  line-height: 15px;
}
.forget-pwd {
  color: #5d94f3;
  font-size: 14px;
  text-align: right;
  margin: 0px auto;
  cursor: pointer;
}
.span-button {
  color: #5e93f6;
  cursor: pointer;
  font-size: 14px;
}
.el-form /deep/ .el-button.is-plain {
  background: #fff;
}
.el-form /deep/ .el-button.is-plain:hover {
  background: #eff4fe;
  color: #5e93f6;
}
.captcha /deep/ .el-input__inner {
  width: calc(300px - 70%);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: transparent;
}
#login-container /deep/ button.captcha {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue